// RenderOrders.jsx
import React from 'react'
import Card from '../../components/UI/Card/index';
import { BsChevronUp, BsChevronDown } from 'react-icons/bs';
import Loader from './../../components/Loader';
import { generatePublicUrl } from '../../urlConfig';
import RenderOrderDetails from './RenderOrderDetails';
import { useDispatch } from 'react-redux';
import { getOrderById, getUserById } from '../../actions';

import LeftContainerInfo from './LeftContainerInfo';
import RenderSettingEditModal from './RenderSettingEditModal';

export const RenderOrders = ({
    orderDetails,
    setShowOrderNumberAdditionalModal,
    setShowDeletingConfirmation,
    setShowPaymentAccountModal,
    showDeletingConfirmation,
    setShowOrderSettingModal,
    handleShowEditOrderModal,
    confirmVisibleOrderById,
    setShowSettingEditModal,
    handleShowSettingModal,
    showSettingEditModal,
    typeEditOrderModal,
    handleTotalAmount,
    showOrderModal,
    confirmDelete,
    setClicked,
    loading,
    clicked,
    orderId,
    orders,
}) => {
    const dispatch = useDispatch()

    const toggle = (orderItem, index) => {
        if (!orderItem?._id) return;

        dispatch(getOrderById(orderItem._id))

        if (orderItem?.user) {
            dispatch(getUserById(orderItem.user))
        }

        if (clicked === index) {
            return setClicked(null);
        }

        setClicked(index);
    };

    const renderOrderImage = (obj, index) => {
        const img = obj?.productId?.productPictures?.[0]?.img;

        return (
            <div
                className="order__img"
                key={obj?._id || obj?.productId?._id || index}
            >
                {img ? (
                    <img src={generatePublicUrl(img)} alt="foto" />
                ) : (
                    <span className="order__imgEmpty">Нет фото</span>
                )}
            </div>
        )
    }

    if (loading) return <Loader />
    if (!Array.isArray(orders) || orders.length === 0) return null

    return (
        <div style={{
            maxWidth: "1200px",
            margin: "0 auto",
        }}>

            {
                orders.map((orderItem, index) => {
                    const orderItems = Array.isArray(orderItem?.items) ? orderItem.items : [];

                    return (
                        <Card
                            onClick={() => toggle(orderItem, index)}
                            style={{
                                margin: "10px 0",
                                background: `${!orderItem?.visibleOrder?.isCompleted ? "rgba(255, 0, 0, 0.316)" : ""}`
                            }}
                            key={orderItem?._id || index}
                        >
                            <div className="order row m-1 p-2">
                                <div className="col-sm-3">
                                    <div className="order__start">
                                        <LeftContainerInfo
                                            orderItem={orderItem}
                                            clicked={clicked}
                                            index={index}
                                            setShowOrderNumberAdditionalModal={setShowOrderNumberAdditionalModal}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <div className="title">
                                        Cумма заказа
                                    </div>
                                    <span className="value">
                                        {orderItem?.totalAmount > 0 ? orderItem.totalAmount : "не посчитано"}
                                    </span>
                                </div>
                                <div className="col-sm-2">
                                    <div className="title">
                                        Со скидкой
                                    </div>
                                    <span className="value">
                                        {orderItem?.totalAmount > 0 ? orderItem.discountForBuyers : "не посчитано"}
                                    </span>
                                </div>
                                <div className="col-sm-5">
                                    <div className="order__renderItemsProductOrder">
                                        <div className="order__rightContainer">
                                            {clicked === index ? null : (
                                                <div className="order__imgContainer">
                                                    {orderItems.map((obj, itemIndex) => renderOrderImage(obj, itemIndex))}
                                                </div>
                                            )}
                                            <div className="order__iconContainer">
                                                <span>
                                                    {clicked === index
                                                        ? <BsChevronDown size="20px" color="#3e77aa" />
                                                        : <BsChevronUp size="20px" color="#3e77aa" />}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <RenderOrderDetails
                                handleShowEditOrderModal={handleShowEditOrderModal}
                                setShowDeletingConfirmation={setShowDeletingConfirmation}
                                setShowPaymentAccountModal={setShowPaymentAccountModal}
                                showDeletingConfirmation={showDeletingConfirmation}
                                setShowOrderSettingModal={setShowOrderSettingModal}
                                confirmVisibleOrderById={confirmVisibleOrderById}
                                setShowSettingEditModal={setShowSettingEditModal}
                                handleShowSettingModal={handleShowSettingModal}
                                handleTotalAmount={handleTotalAmount}
                                showOrderModal={showOrderModal}
                                confirmDelete={confirmDelete}
                                setClicked={setClicked}
                                orderDetails={orderDetails}
                                clicked={clicked}
                                orderId={orderId}
                                index={index}
                            />
                        </Card>
                    );
                })
            }
            <RenderSettingEditModal
                show={showSettingEditModal}
                typeEditOrderModal={typeEditOrderModal}
                handleClose={() => setShowSettingEditModal(false)}
                orderDetails={orderDetails}
            />
        </div>
    )
}